export const dummyFeedbackData = [
    // 20 good ratings
    { id: 1, rating: 'good', comment: 'シフトの時間帯がとても良く、学校との両立ができています。急な変更にも柔軟に対応してくれて助かります。' },
    { id: 2, rating: 'good', comment: 'シフトの希望を聞いてもらえて、自分の都合に合わせて調整してもらえました。とても働きやすいです。' },
    { id: 3, rating: 'good', comment: 'シフトの連絡が早めに来るので、予定を立てやすくて良いです。時間通りに終われるのも嬉しいです。' },
    { id: 4, rating: 'good', comment: 'シフトの時間が適切で、体力的にも無理なく働けます。休憩時間もきちんと取れています。' },
    { id: 5, rating: 'good', comment: 'シフトの変更依頼が簡単にできて、急な用事があっても対応してもらえます。' },
    { id: 6, rating: 'good', comment: 'シフトの希望時間を出したら、ほぼその通りに組んでもらえました。とても満足しています。' },
    { id: 7, rating: 'good', comment: 'シフトの連絡が分かりやすく、アプリで確認できるのが便利です。' },
    { id: 8, rating: 'good', comment: 'シフトの時間が安定していて、収入の見通しが立てやすいです。' },
    { id: 9, rating: 'good', comment: 'シフトの希望を聞いてもらえて、自分の都合に合わせて調整してもらえました。' },
    { id: 10, rating: 'good', comment: 'シフトの時間が適切で、他のバイトや学校との調整がしやすいです。' },
    { id: 11, rating: 'good', comment: 'シフトの変更が簡単にできて、急な予定変更にも対応してもらえます。' },
    { id: 12, rating: 'good', comment: 'シフトの連絡が早めに来るので、予定を立てやすくて良いです。' },
    { id: 13, rating: 'good', comment: 'シフトの時間が自分の生活リズムに合っていて、体調も良く保てています。' },
    { id: 14, rating: 'good', comment: 'シフトの希望を出したら、ほぼその通りに組んでもらえました。' },
    { id: 15, rating: 'good', comment: 'シフトの変更依頼が簡単にできて、急な用事があっても対応してもらえます。' },
    { id: 16, rating: 'good', comment: 'シフトの時間が安定していて、収入の見通しが立てやすいです。' },
    { id: 17, rating: 'good', comment: 'シフトの連絡が分かりやすく、アプリで確認できるのが便利です。' },
    { id: 18, rating: 'good', comment: 'シフトの時間が適切で、他のバイトや学校との調整がしやすいです。' },
    { id: 19, rating: 'good', comment: 'シフトの希望を聞いてもらえて、自分の都合に合わせて調整してもらえました。' },
    { id: 20, rating: 'good', comment: 'シフトの時間が自分の生活リズムに合っていて、体調も良く保てています。' },
    
    // 5 neutral ratings
    { id: 21, rating: 'neutral', comment: 'シフトの時間は特に問題ありませんが、もう少し希望時間を聞いてもらえると良いと思います。' },
    { id: 22, rating: 'neutral', comment: 'シフトの連絡は来ますが、もう少し早めに連絡があると助かります。' },
    { id: 23, rating: 'neutral', comment: 'シフトの時間は普通ですが、もう少し柔軟に対応してもらえると良いです。' },
    { id: 24, rating: 'neutral', comment: 'シフトの希望を出しても、あまり反映されないことがあります。' },
    { id: 25, rating: 'neutral', comment: 'シフトの時間は特に不満はありませんが、もう少し改善の余地があると思います。' },
    
    // 5 bad ratings
    { id: 26, rating: 'bad', comment: 'シフトの変更依頼を出しても、全然対応してもらえません。急な用事があっても変更できないのが困ります。' },
    { id: 27, rating: 'bad', comment: 'シフトの連絡が遅すぎて、予定が立てられません。前日になってから連絡が来ることもあります。' },
    { id: 28, rating: 'bad', comment: 'シフトの希望時間を出しても、全然聞いてもらえません。自分の都合を無視されて困っています。' },
    { id: 29, rating: 'bad', comment: 'シフトの時間が不安定で、収入の見通しが立てられません。急にシフトが減らされることもあります。' },
    { id: 30, rating: 'bad', comment: 'シフトの変更が複雑すぎて、簡単にできないのが不便です。アプリも使いにくいです。' }
]; 